import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import {Currency} from "models"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
/**
 * @typedef {object} ComponentsCurrenciesLinkProps
 * @property {boolean} adminLayout
 * @property {unknown} children
 * @property {string} className
 * @property {unknown} currency
 * @property {boolean} superAdminLayout
 * @property {boolean} userLayout
 */

/** @typedef {object} ComponentsCurrenciesLinkState */

/**
 * @extends {ShapeComponent<ComponentsCurrenciesLinkProps, ComponentsCurrenciesLinkState>}
 */
class ComponentsCurrenciesLink extends ShapeComponent {
  static propTypes = {
    adminLayout: PropTypes.bool,
    className: PropTypes.string,
    superAdminLayout: PropTypes.bool,
    currency: PropTypes.instanceOf(Currency).isRequired,
    userLayout: PropTypes.bool
  }

  render() {
    const {adminLayout = false, children, className, currency, superAdminLayout = false, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--currencies--link", className)
    let to

    if (adminLayout || superAdminLayout) {
      to = Routes.superAdminPath({model: "Currency", model_id: currency.id()})
    } else {
      to = "#"
    }

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || currency.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || currency.name()}
      </span>
    )
  }
}

export default memo(shapeComponent(ComponentsCurrenciesLink))
